import React, { useEffect } from 'react';
import {useSelector,useDispatch} from 'react-redux';
import Login from '../../../../Login/Login';
import { confirmMail,userTokenVerify,addUserAuthToken } from '../../../../../general_redux/user/actions';

const MailConfirm = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        console.log("Compoent mail update rendered")
        if (props && props.match && props.match.params && props.match.params.token) {
            dispatch(userTokenVerify(props.match.params.token))
            dispatch(addUserAuthToken(props.match.params.token))
        }
    }, [props, dispatch])

    return (
        <div>
            <Login/>
        </div>
    )
}

export default MailConfirm;